import MenteeHeader from "../../../components/MenteeHeader";
import Background from "../../../components/Background";
import { useMemo, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  List,
  ListItem,
} from "@mui/material";
import Mobilesidebar from "../../../components/Mobilesidebar";
import Sidebar from "../../../components/Sidebar";
import BasicDetailsEditProfile from "./BasicDetailsEditProfile";
import { useDispatch, useSelector } from "react-redux";
import RoundedTextField from "../../../components/RoundedTextField";
import { useNavigate } from "react-router-dom";
import { baseFetch } from "../../../helpers/apiClient";
import {
  clearUpdatedFields,
  fetchProfileInfo,
} from "../../../redux/profileSlice";
import SuccessModal from "../../../components/SuccessModal";
import { toggleSessionModal } from "../../../redux/sessionSlice";
import Loader from "../../../components/Loader";
import {
  EDIT_PROFILE_PANEL_MAX_HEIGHT,
  EDIT_PROFILE_PAGE_PADDING,
} from "../../../helpers/layoutConstants";
import {
  buildSponsorLocalProfile,
  buildSponsorProfileUpdate,
} from "./sponsorProfileHelpers";

const SponsorEditProfile = () => {
  const profileInfo = useSelector((state) => state.profileSlice.profile);
  const updatedFields = useSelector(
    (state) => state.profileSlice?.updatedFields,
  );
  console.log("updated Fields are", updatedFields);
  const localProfile = useMemo(
    () => buildSponsorLocalProfile(profileInfo, updatedFields),
    [profileInfo, updatedFields],
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  console.log("local profile is", localProfile);
  const navigate = useNavigate();
  let emptyFields;
  if (
    updatedFields?.firstName === "" ||
    updatedFields?.lastName === "" ||
    updatedFields?.sponsorProfile?.companyName === ""
  ) {
    emptyFields = true;
  } else {
    emptyFields = false;
  }
  const disable = Object.keys(updatedFields).length === 0 || emptyFields;

  const handleSaveChanges = async () => {
    setLoading(true);
    const payload = buildSponsorProfileUpdate(profileInfo, updatedFields);
    await baseFetch({
      url: `/v2/me/profile`,
      method: "PUT",
      body: payload,
    })
      .then((response) => {
        if (response.status) {
          setLoading(false);
          setOpen(true);
          dispatch(clearUpdatedFields());
          dispatch(fetchProfileInfo());
        }
      })
      .catch((err) => {
        setLoading(false);
        //handleBackStep()
        if (err === "Please authenticate") {
          dispatch(toggleSessionModal(false));
        }
      });
  };

  console.log("updatedFields", updatedFields);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <Background extraSpacing={true}>
        <MenteeHeader
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
        />
        {loading && <Loader />}
        <Box>
          <Box
            sx={{
              padding: EDIT_PROFILE_PAGE_PADDING,
            }}
          >
            <Container maxWidth="xl">
              <Grid container spacing={{ lg: 3, sm: 2, xs: 2 }}>
                <Grid item xs={12} sm={4} md={3} lg={3}>
                  <Mobilesidebar />
                  <Sidebar />
                </Grid>
                <Grid item xs={12} sm={8} md={9} lg={9}>
                  <Box
                    sx={{
                      padding: {
                        xs: "7px 15px",
                        sm: "20px 30px",
                      },
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      boxShadow: " 0px 20px 20px 0px #2A48761A",
                    }}
                  >
                    <Box
                      sx={{
                        maxHeight: EDIT_PROFILE_PANEL_MAX_HEIGHT,
                        overflowY: "auto",
                        paddingRight: "10px",
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sx={{
                            paddingRight: {
                              xs: 0,
                              sm: 0,
                              md: 0,
                              lg: "20px",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#2A4876",
                              fontWeight: "700",
                              textAlign: "left",
                            }}
                            variant="h6"
                          >
                            Edit Profile
                          </Typography>
                          <BasicDetailsEditProfile
                            localProfile={localProfile}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography
                            mb={0.5}
                            sx={{
                              fontSize: "14px",
                              textAlign: "left",
                            }}
                            component="dt"
                          >
                            Organizational Scope
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "6px",
                              marginTop: "8px",
                            }}
                          >
                            <RoundedTextField
                              fullWidth
                              size="small"
                              name="firstName"
                              value={
                                localProfile.profile?.sponsorProfile
                                  ?.organizationalScope || ""
                              }
                              sx={{
                                marginBottom: "12px",
                                borderRadius: "50px",
                                backgroundColor: "#F2F7FB",
                                "& .MuiOutlinedInput-input": {
                                  color: "#2A4876",
                                },
                              }}
                            />
                            <Button
                              style={{
                                border: "1px solid #AAB6C8",
                                padding: "10px 26px",
                                borderRadius: "24px",
                                textTransform: "none",
                                color: "#152134",
                                position: "relative",
                                top: "-5px",
                              }}
                              onClick={() => {
                                navigate("/profile/edit-location-sponsor", {
                                  state: { localProfile },
                                });
                              }}
                            >
                              {" "}
                              Edit
                            </Button>
                          </Box>
                          {localProfile.profile?.sponsorProfile
                            ?.organizationalScope === "local" && (
                            <>
                              <Typography
                                mb={0.5}
                                sx={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                }}
                                component="dt"
                              >
                                City
                              </Typography>
                              <RoundedTextField
                                fullWidth
                                size="small"
                                name="firstName"
                                value={
                                  localProfile.profile?.sponsorProfile
                                    ?.primaryCity || ""
                                }
                                sx={{
                                  marginBottom: "12px",
                                  borderRadius: "50px",
                                  backgroundColor: "#F2F7FB",
                                  "& .MuiOutlinedInput-input": {
                                    color: "#2A4876",
                                  },
                                }}
                              />
                              <Typography
                                mb={0.5}
                                sx={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                }}
                                component="dt"
                              >
                                Province
                              </Typography>
                              <RoundedTextField
                                fullWidth
                                size="small"
                                name="firstName"
                                value={
                                  localProfile.profile?.sponsorProfile
                                    ?.province || ""
                                }
                                sx={{
                                  marginBottom: "12px",
                                  borderRadius: "50px",
                                  backgroundColor: "#F2F7FB",
                                  "& .MuiOutlinedInput-input": {
                                    color: "#2A4876",
                                  },
                                }}
                              />
                            </>
                          )}
                          {localProfile.profile?.sponsorProfile
                            ?.organizationalScope === "international" && (
                            <>
                              <Typography
                                mb={0.5}
                                sx={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                }}
                                component="dt"
                              >
                                Countries/Cities
                              </Typography>
                              <RoundedTextField
                                fullWidth
                                size="small"
                                value={
                                  localProfile.profile?.sponsorProfile
                                    ?.countriesOrCities || ""
                                }
                                sx={{
                                  marginBottom: "12px",
                                  borderRadius: "50px",
                                  backgroundColor: "#F2F7FB",
                                  "& .MuiOutlinedInput-input": {
                                    color: "#2A4876",
                                  },
                                }}
                              />
                            </>
                          )}
                          {localProfile.profile?.sponsorProfile
                            ?.organizationalScope === "regional" && (
                            <>
                              <Typography
                                mb={0.5}
                                sx={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                }}
                                component="dt"
                              >
                                Regions
                              </Typography>
                              <List>
                                {localProfile.profile?.sponsorProfile?.regions?.map(
                                  (region) => (
                                    <ListItem
                                      key={region}
                                      sx={{
                                        display: "list-item",
                                        color: "#2A4876", // Text color
                                        fontSize: "16px",
                                        "&::marker": {
                                          color: "red", // Bullet color (may not work in all browsers)
                                          fontSize: "20px",
                                        },
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "black", // Bullet color
                                          fontSize: "20px",
                                          marginRight: "8px",
                                        }}
                                      >
                                        •
                                      </span>
                                      {region}
                                    </ListItem>
                                  ),
                                )}
                              </List>
                            </>
                          )}
                          {open && (
                            <SuccessModal
                              open={open}
                              onClose={() => {
                                setOpen(false);
                              }}
                              title="Profile Updated Successfully"
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        marginTop: "14px",
                        width: {
                          xs: "100%",
                          sm: "60%",
                          md: "50%",
                          lg: "35%",
                        },
                        textAlign: "left",
                      }}
                    >
                      <Button
                        sx={{
                          padding: "10px 20px",
                          borderRadius: "50px",
                          textAlign: "center",
                          backgroundColor: "#2A4876",
                          width: "80%",
                          color: "white",
                          textTransform: "none",
                          "&:disabled": {
                            backgroundColor: "#AAB6C8",
                          },
                        }}
                        disabled={disable}
                        onClick={handleSaveChanges}
                      >
                        Save Changes
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </Background>
    </>
  );
};

export default SponsorEditProfile;
